import React, { useState, useEffect } from "react";
import { logApi } from "../../api/Api";

const SolarSvg2 = ({ svgColor }) => {
    const [logData, setLogData] = useState(null); // Initialize as null or an object
    const [credentials, setCredentials] = useState({
        LOGIN_ID: localStorage.getItem("LoginID"),
        LOC_CODE: localStorage.getItem("LCODE"),
        PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
        WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
    });

    const fetchLogData = async () => {
        try {
            const res = await logApi(credentials);
            if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
                // Assuming you need the first object in the array
                setLogData(res.TOT_LIVE_KW_NEW[0]);
            } else {
                setLogData(null); // Handle no data scenario
            }
        } catch (error) {
            console.error("Error fetching log data:", error);
            setLogData(null); // Handle error scenario
        }
    };

    useEffect(() => {
        fetchLogData();
    }, [credentials]);



    // Determine the color for the SOLAR value
  const solarColor =
  logData?.SOLAR == null
    ? "gray" // No data
    : logData.SOLAR <= 0
    ? "red" // Solar < 1
    : "green"; // Solar >= 1

    // Determine the color for the LOAD value
  const loadColor =
  logData?.TOTAL_LOAD == null
    ? "gray" // No data
    : logData.TOTAL_LOAD <= 0
    ? "red" // Solar < 1
    : "green"; // Solar >= 1


    // Determine the color for the DG value
    const dgColor =
  logData?.GenSet == null
    ? "gray" // No data
    : logData.GenSet <= 0
    ? "red" // Solar <= 0
    : "green"; // Solar > 0


    

    return (
        <>
            <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 897.000000 492.000000"
                preserveAspectRatio="xMidYMid meet"
            >
                <g
                    transform="translate(0.000000,492.000000) scale(0.100000,-0.100000)"
                    fill="#000000"
                    stroke={svgColor}
                >
                   {/* // GRID PATH  */}
                    <path
  d="M7253 4788 c-6 -7 -32 -76 -58 -153 l-49 -140 -85 -90 c-47 -49 -97
  -98 -110 -109 -67 -56 -107 -156 -62 -156 13 0 21 8 23 23 2 14 10 22 23 22
  13 0 21 -8 23 -22 5 -33 42 -31 42 2 0 23 4 25 45 25 38 0 45 3 45 20 0 18 -7
  20 -72 20 l-73 0 90 90 c49 50 93 90 97 90 5 0 8 -53 8 -117 l0 -118 -131
  -131 c-117 -117 -131 -135 -136 -172 -5 -38 -4 -42 16 -42 16 0 21 6 21 25 0
  20 5 25 25 25 20 0 25 -5 25 -25 0 -18 5 -25 20 -25 15 0 20 7 20 25 0 23 4
  25 45 25 38 0 45 3 45 20 0 18 -7 20 -72 20 l-73 0 90 90 c49 50 93 90 97 90
  5 0 8 -53 8 -117 l0 -117 -86 -218 -86 -218 -179 0 c-113 0 -179 -4 -179 -10
  0 -7 240 -10 700 -10 460 0 700 3 700 10 0 6 -66 10 -178 10 l-179 0 -16 38
  c-9 20 -48 117 -87 215 l-70 177 0 120 c0 66 3 120 8 120 4 0 48 -40 97 -90
  l90 -90 -73 0 c-65 0 -72 -2 -72 -20 0 -17 7 -20 45 -20 38 0 45 -3 45 -20 0
  -13 7 -20 20 -20 13 0 20 7 20 20 0 15 7 20 25 20 20 0 25 -5 25 -25 0 -19 5
  -25 21 -25 20 0 21 4 16 42 -5 37 -19 55 -136 172 l-131 131 0 118 c0 64 3
  117 8 117 14 0 183 -176 176 -183 -4 -4 -36 -7 -71 -7 -48 0 -63 -3 -63 -14 0
  -10 14 -16 43 -18 35 -2 43 -7 45 -25 2 -15 10 -23 22 -23 12 0 20 8 22 23 2
  14 10 22 23 22 13 0 21 -8 23 -22 2 -15 10 -23 23 -23 15 0 19 7 19 36 0 34
  -12 49 -138 178 l-139 141 -43 125 c-63 183 -61 180 -119 180 -27 0 -53 -6
  -58 -12z m87 -31 c0 -2 20 -59 45 -127 25 -68 45 -127 45 -132 0 -4 -54 -8
  -120 -8 -93 0 -120 3 -120 13 0 13 76 232 86 249 5 7 64 12 64 5z m60 -315 c0
  -4 -20 -28 -45 -52 l-45 -44 -53 52 -52 52 98 0 c53 0 97 -4 97 -8z m-167 -80
  l47 -48 -50 -49 -50 -49 0 97 c0 53 1 97 3 97 1 0 24 -22 50 -48z m207 -49 l0
  -97 -50 49 -50 49 47 48 c26 26 49 48 50 48 2 0 3 -44 3 -97z m-82 -76 c23
  -23 42 -46 42 -50 0 -4 -44 -7 -97 -7 l-97 0 49 50 c27 28 52 50 55 50 3 0 25
  -19 48 -43z m42 -100 c0 -1 -22 -24 -48 -50 l-48 -47 -49 50 -49 50 97 0 c53
  0 97 -1 97 -3z m-167 -85 l47 -48 -50 -49 -50 -49 0 97 c0 53 1 97 3 97 1 0
  24 -22 50 -48z m207 -49 l0 -97 -50 49 -50 49 47 48 c26 26 49 48 50 48 2 0 3
  -44 3 -97z m-67 -91 l57 -58 -63 -62 -63 -62 -59 60 -59 60 59 60 c33 33 62
  60 65 60 3 0 31 -26 63 -58z m-222 -341 c-68 -72 -127 -131 -131 -131 -5 0 21
  73 57 163 36 89 69 173 75 186 9 25 9 24 65 -31 l56 -57 -122 -130z m379 59
  c40 -100 71 -183 68 -185 -2 -2 -61 53 -131 123 l-127 128 51 57 c28 31 54 57
  59 57 4 0 40 -81 80 -180z m-100 -85 l115 -115 -235 0 -235 0 115 115 c63 63
  117 115 120 115 3 0 57 -52 120 -115z"
  fill={
    logData?.GRID == null
      ? "gray" // No data
      : logData.GRID <= 0
      ? "red" // Grid < 1
      : "green" // Grid > 0
  }

  
/>


{/* // SOLAR PATH */}

<path d="M497 4723 c-4 -3 -7 -24 -7 -45 0 -32 3 -39 18 -36 22 4 29 60 9 76
-8 7 -17 9 -20 5z" fill={solarColor}/>
<path d="M346 4681 c-8 -12 18 -66 35 -76 24 -15 32 13 13 46 -21 35 -38 46
-48 30z" fill={solarColor}/>
<path d="M631 4664 c-23 -29 -24 -55 -4 -61 18 -6 50 64 36 78 -7 7 -17 2 -32
-17z" fill={solarColor}/>
<path fill={solarColor} d="M420 4567 c-112 -59 -120 -235 -15 -306 20 -13 37 -22 39 -20 1 2 13
41 26 87 14 52 30 86 41 92 10 6 54 10 98 10 68 0 81 3 81 16 0 35 -34 85 -78
114 -58 39 -128 41 -192 7z"/>
<path d="M236 4572 c-7 -12 6 -28 41 -46 43 -22 56 -1 19 31 -28 23 -51 29
-60 15z" fill={solarColor}/>
<path d="M722 4560 c-28 -17 -32 -23 -22 -36 11 -12 17 -12 44 4 30 18 41 42
21 49 -5 1 -25 -6 -43 -17z" fill={solarColor}/>
<path d="M202 4413 c4 -24 83 -27 83 -3 0 11 -13 16 -43 18 -38 3 -43 1 -40
-15z" fill={solarColor}/>
<path d="M502 4330 l-21 -60 79 0 78 0 7 38 c3 20 9 47 12 60 5 21 3 22 -65
22 l-70 0 -20 -60z" fill={solarColor}/>
<path d="M681 4346 c-19 -77 -21 -76 69 -76 76 0 80 1 80 23 0 12 3 39 6 60
l7 37 -76 0 -75 0 -11 -44z" fill={solarColor}/>
<path d="M866 4359 c-3 -17 -6 -44 -6 -60 l0 -29 95 0 95 0 0 60 0 60 -89 0
-88 0 -7 -31z" fill={solarColor}/>
<path d="M1080 4330 l0 -60 85 0 c47 0 85 3 85 8 0 4 -6 30 -13 57 l-13 50
-72 3 -72 3 0 -61z" fill={solarColor}/>
<path d="M1254 4373 c3 -10 10 -37 16 -60 l11 -43 75 0 c67 0 75 2 70 18 -2 9
-10 36 -17 60 l-12 42 -74 0 c-66 0 -74 -2 -69 -17z" fill={solarColor}/>
<path d="M255 4286 c-25 -21 -27 -25 -13 -31 21 -8 78 21 78 40 0 22 -31 18
-65 -9z" fill={solarColor}/>
<path d="M453 4175 l-21 -66 86 3 c95 3 89 -2 106 91 l7 37 -79 0 -78 0 -21
-65z" fill={solarColor}/>
<path d="M648 4178 l-13 -63 89 -3 c49 -1 90 -1 91 0 1 2 5 31 9 66 l7 62 -85
0 -84 0 -14 -62z" fill={solarColor}/>
<path d="M856 4209 c-3 -17 -6 -47 -6 -65 l0 -34 111 0 c97 0 110 2 105 16 -3
9 -6 38 -6 65 l0 49 -99 0 -98 0 -7 -31z" fill={solarColor}/>
<path d="M1090 4198 c0 -88 1 -88 102 -88 l89 0 -7 38 c-17 92 -11 87 -102 90
l-82 3 0 -43z" fill={solarColor}/>
<path d="M1283 4233 c3 -4 10 -34 17 -65 l11 -58 85 0 c79 0 85 1 79 19 -3 10
-11 38 -18 62 l-13 44 -83 3 c-45 2 -81 -1 -78 -5z" fill={solarColor} />
<path d="M357 4190 c-18 -29 -16 -50 4 -50 12 0 49 61 43 72 -10 16 -30 7 -47
-22z" fill={solarColor} />

<path d="M402 4012 c-12 -38 -22 -71 -22 -75 0 -4 42 -7 93 -7 l92 0 16 69 15
69 -29 6 c-16 3 -55 6 -86 6 l-57 0 -22 -68z"fill={solarColor}/>
<path d="M626 4068 c-10 -32 -26 -108 -26 -123 0 -13 14 -15 103 -13 l102 3 3
66 c3 62 1 67 -20 73 -43 11 -158 7 -162 -6z" fill={solarColor}/>
<path d="M840 4016 c0 -30 -3 -61 -6 -70 -5 -14 9 -16 120 -16 l126 0 0 33 c0
17 -3 49 -6 70 l-7 37 -113 0 -114 0 0 -54z" fill={solarColor}/>
<path d="M1100 4053 c0 -10 3 -42 6 -70 l7 -53 104 0 c95 0 104 2 100 18 -3 9
-11 41 -17 70 l-12 52 -94 0 c-83 0 -94 -2 -94 -17z" fill={solarColor}/>
<path d="M1320 4063 c0 -5 4 -24 9 -43 5 -19 12 -47 15 -62 l6 -28 90 0 c50 0
90 3 90 6 0 3 -8 35 -17 70 l-17 64 -88 0 c-48 0 -88 -3 -88 -7z" fill={solarColor}/>

<path d="M367 3893 c-2 -5 -14 -40 -26 -80 -12 -40 -24 -79 -27 -88 -5 -13 9
-15 99 -15 l106 0 16 78 c9 42 19 85 22 95 4 15 -5 17 -91 17 -52 0 -97 -3
-99 -7z" fill={solarColor}/>

<path d="M586 3883 c-2 -10 -10 -45 -16 -78 -6 -33 -14 -68 -16 -77 -5 -16 5
-18 115 -18 l121 0 0 28 c0 15 3 57 7 95 l6 67 -106 0 c-92 0 -106 -2 -111
-17z" fill={solarColor}/>

<path d="M826 3848 c-3 -29 -6 -72 -6 -95 l0 -43 139 0 138 0 -4 53 c-2 28 -6
71 -9 95 l-5 42 -123 0 -123 0 -7 -52z" fill={solarColor}/>

<path d="M1116 3818 c3 -46 7 -89 10 -95 2 -10 35 -13 119 -13 85 0 115 3 115
13 0 6 -9 48 -18 92 l-18 80 -107 3 -106 3 5 -83z" fill={solarColor}/>
<path d="M1374 3805 l21 -95 102 0 c57 0 103 3 103 8 0 4 -7 30 -15 57 -9 28
-20 67 -26 88 l-10 37 -98 0 -98 0 21 -95z" fill={solarColor}/>
<path d="M930 3580 l0 -100 30 0 30 0 0 100 0 100 -30 0 -30 0 0 -100z" fill={solarColor}/>
<path d="M573 3400 c-57 -27 -103 -51 -103 -54 0 -3 218 -6 485 -6 267 0 485
4 485 8 0 4 -46 29 -102 55 l-103 47 -280 0 -280 0 -102 -50z"fill={solarColor}/>


{/* // PATH  */}
<path d="M1980 4090 c0 -6 27 -10 60 -10 33 0 60 4 60 10 0 6 -27 10 -60 10
-33 0 -60 -4 -60 -10z" fill={svgColor}/>
<path d="M2170 4090 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>
<path d="M2360 4090 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>
<path d="M2550 4090 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>

<path d="M2740 4045 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z" fill={svgColor}/>

<path d="M5330 4075 c0 -14 5 -25 10 -25 6 0 10 7 10 15 0 10 10 15 30 15 17
0 30 5 30 10 0 6 -18 10 -40 10 -36 0 -40 -2 -40 -25z" fill={svgColor}/>

<path d="M5490 4090 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>
<path d="M5680 4090 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>
<path d="M5870 4090 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>

<path d="M5330 3545 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z" fill={svgColor}/>
<path d="M2740 3485 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z" fill={svgColor}/>
<path d="M2740 3675 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z" fill={svgColor}/>
<path d="M5330 3735 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z" fill={svgColor}/>
<path d="M2740 3865 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z" fill={svgColor}/>
<path d="M5330 3925 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z" fill={svgColor}/>
<path d="M5330 3355 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z" fill={svgColor}/>

<path d="M2740 3300 c0 -27 5 -50 10 -50 6 0 10 23 10 50 0 28 -4 50 -10 50
-5 0 -10 -22 -10 -50z" fill={svgColor}/>

<path d="M3945 3026 c-133 -44 -234 -130 -290 -249 -125 -263 8 -572 282 -657
216 -67 451 37 548 242 76 161 65 330 -31 473 -48 74 -104 120 -194 164 -69
33 -83 36 -175 38 -63 2 -115 -2 -140 -11z m296 -63 c223 -104 314 -356 210
-578 -89 -190 -300 -287 -497 -227 -125 38 -210 111 -268 232 -29 61 -31 72
-31 180 0 108 2 119 32 182 53 113 137 187 258 231 81 28 212 20 296 -20z" fill={svgColor}/>



<path d="M5330 2965 c0 -19 5 -35 10 -35 6 0 10 16 10 35 0 19 -4 35 -10 35
-5 0 -10 -16 -10 -35z" fill={svgColor}/>

<path d="M2740 2925 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z" fill={svgColor}/>

<path d="M5330 2795 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z" fill={svgColor}/>

<path d="M3346 2828 c4 -7 20 -32 36 -55 15 -23 28 -48 28 -55 0 -7 -16 -37
-35 -67 -19 -30 -33 -56 -32 -58 6 -6 268 114 269 123 0 8 -245 122 -265 123
-5 1 -5 -5 -1 -11z" fill={svgColor}/>



<path d="M2740 2750 c0 -36 3 -40 25 -40 14 0 25 5 25 10 0 6 -7 10 -15 10
-10 0 -15 10 -15 30 0 17 -4 30 -10 30 -5 0 -10 -18 -10 -40z" fill={svgColor}/>

<path d="M2870 2720 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>

<path d="M3050 2720 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>


<path d="M3240 2720 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>
<path d="M4610 2720 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>
<path d="M4800 2720 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>



<path d="M4990 2720 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>
<path d="M5170 2720 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>
<path d="M2740 2440 c0 -16 5 -30 10 -30 6 0 10 9 10 20 0 15 7 20 25 20 14 0
25 5 25 10 0 6 -16 10 -35 10 -32 0 -35 -2 -35 -30z" fill={svgColor}/>
<path d="M2890 2460 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>



<path d="M3070 2460 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>
<path d="M3260 2460 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>
<path d="M3450 2460 c0 -5 20 -10 45 -10 25 0 45 5 45 10 0 6 -20 10 -45 10
-25 0 -45 -4 -45 -10z" fill={svgColor}/>
<path d="M4540 2460 c0 -5 9 -10 20 -10 11 0 20 5 20 10 0 6 -9 10 -20 10 -11
0 -20 -4 -20 -10z" fill={svgColor}/>
<path d="M4660 2460 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>
<path d="M4850 2460 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>




<path d="M5040 2460 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>
<path d="M5220 2460 c0 -5 24 -10 54 -10 30 0 58 5 61 10 4 6 -17 10 -54 10
-34 0 -61 -4 -61 -10z" fill={svgColor}/>
<path d="M5320 2325 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z" fill={svgColor}/>
<path d="M2740 2275 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z" fill={svgColor}/>
<path d="M5320 2145 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z" fill={svgColor}/>
<path d="M2740 2095 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z" fill={svgColor}/>
<path d="M5320 1955 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z" fill={svgColor}/>
<path d="M2740 1905 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z" fill={svgColor}/>
<path d="M5320 1765 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z" fill={svgColor}/>
<path d="M2740 1715 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z" fill={svgColor}/>
{/* PATH */}

{/* // LOAD */}

<path d="M7300 1927 c-20 -18 -183 -162 -363 -322 l-328 -289 40 -40 40 -40
23 21 c171 155 622 553 628 553 4 0 154 -130 333 -289 l325 -290 35 42 35 43
-359 319 c-198 176 -363 321 -367 322 -4 1 -23 -12 -42 -30z" fill={loadColor}/>

<path d="M6830 1739 l0 -130 28 20 c70 51 141 130 147 164 13 69 4 77 -91 77
l-84 0 0 -131z" fill={loadColor}/>
<path d="M7110 1509 c-124 -109 -237 -212 -253 -229 l-27 -31 2 -332 3 -332
167 -3 166 -2 4 142 c1 79 7 149 11 156 6 9 49 12 157 12 108 0 151 -3 157
-12 4 -7 10 -77 11 -156 l4 -142 166 2 167 3 3 323 c2 245 -1 328 -10 346 -12
22 -487 456 -498 455 -3 0 -106 -90 -230 -200z" fill={loadColor}/>

{/* // DG */}

<path d="M1714 1732 c-28 -25 -64 -83 -64 -104 0 -4 38 -8 85 -8 l85 0 0 70 0
70 -37 0 c-27 -1 -47 -9 -69 -28z" fill={dgColor}/>

<path d="M1850 1690 l0 -70 43 0 c48 0 53 5 81 93 l15 47 -70 0 -69 0 0 -70z" fill={dgColor}/>



<path d="M1650 1575 c0 -13 -82 -15 -679 -15 -671 0 -679 0 -705 -21 l-26 -20
0 -398 c0 -327 2 -401 14 -417 14 -18 36 -19 853 -22 609 -2 846 1 866 9 l27
11 0 414 0 413 -22 15 c-15 11 -45 16 -90 16 -54 0 -68 3 -68 15 0 12 -16 15
-85 15 -69 0 -85 -3 -85 -15z m-422 -105 c12 -12 22 -29 22 -40 0 -27 -39 -60
-70 -60 -31 0 -70 33 -70 60 0 27 39 60 70 60 14 0 36 -9 48 -20z m285 -12
l21 -28 -21 -27 c-26 -36 -70 -41 -101 -13 -12 11 -22 29 -22 40 0 11 10 29
22 40 31 28 75 23 101 -12z m272 7 c14 -13 25 -29 25 -35 0 -21 -49 -60 -75
-60 -30 0 -65 32 -65 60 0 28 35 60 65 60 14 0 37 -11 50 -25z m-910 -60 l25
-24 0 -265 0 -265 -33 -25 c-34 -26 -34 -26 -247 -26 l-214 0 -28 27 c-17 16
-28 37 -28 54 0 18 -6 28 -20 32 -16 4 -20 14 -20 46 0 30 5 44 20 53 18 11
20 24 20 108 0 84 -2 97 -20 108 -28 17 -28 77 0 94 11 7 20 23 20 36 0 13 11
34 25 47 l24 25 226 0 226 0 24 -25z m794 -126 c17 -6 36 -19 41 -29 6 -11 10
-116 10 -244 l0 -225 -27 -21 c-26 -20 -36 -21 -246 -18 -203 3 -220 4 -233
22 -11 16 -14 67 -14 251 0 246 1 250 50 268 29 11 386 7 419 -4z" fill={dgColor} />

<path d="M402 1394 c-22 -15 -22 -18 -22 -279 0 -251 1 -265 19 -275 28 -14
413 -13 446 2 l25 11 0 259 c0 245 -1 259 -20 278 -19 19 -33 20 -223 20 -167
0 -206 -3 -225 -16z m378 -134 l0 -30 -155 0 c-129 0 -157 3 -161 15 -4 8 -4
22 0 30 4 12 32 15 161 15 l155 0 0 -30z m50 -171 c0 -33 -3 -40 -17 -37 -32
6 -30 78 2 78 11 0 15 -11 15 -41z" fill={dgColor}/>

<path d="M1250 1016 c0 -195 2 -225 16 -230 20 -8 368 -8 388 0 14 5 16 35 16
230 l0 224 -210 0 -210 0 0 -224z m303 157 c-15 -27 -38 -64 -51 -83 l-24 -35
63 -3 62 -3 -33 -35 c-19 -18 -39 -34 -45 -34 -6 0 -38 -25 -71 -55 -47 -44
-144 -112 -144 -101 0 1 18 21 39 45 22 24 53 63 71 87 l31 44 -60 0 c-66 0
-74 7 -37 30 13 8 68 54 120 103 53 48 99 87 102 87 3 0 -8 -21 -23 -47z" fill={dgColor}/>

<path d="M240 643 c0 -43 17 -53 86 -53 53 0 62 -3 67 -20 5 -19 14 -20 121
-20 109 0 116 1 116 20 0 20 7 20 489 20 480 0 489 0 494 -20 5 -19 14 -20
126 -20 113 0 121 1 121 20 0 17 8 19 68 22 l67 3 3 37 c3 37 3 37 -25 28 -35
-13 -1690 -9 -1715 4 -15 7 -18 3 -18 -21z" fill={dgColor}/>


{/* // PATH */}

<path d="M5320 1381 c0 -28 5 -51 10 -51 6 0 10 20 10 44 0 25 -4 48 -10 51
-6 4 -10 -13 -10 -44z" fill={svgColor}/>

<path d="M2740 1335 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z" fill={svgColor}/>

<path d="M5320 1205 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z" fill={svgColor}/>

<path d="M2740 1155 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z" fill={svgColor}/>

<path
  d="M5851 1188 c7 -13 23 -40 37 -61 l25 -37 -37 -56 c-21 -31 -35 -58
  -32 -61 8 -8 267 109 264 119 -3 9 -244 118 -260 118 -5 0 -3 -10 3 -22z"
  className={logData?.TOTAL_LOAD > 0 ? 'blink' : ''}
  fill={logData?.TOTAL_LOAD > 0 ? 'red' : svgColor}
/>


<path d="M2190 1090 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>
<path d="M2380 1090 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>
<path d="M2570 1090 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>
<path d="M5350 1090 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>
<path d="M5540 1090 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>
<path d="M5730 1090 c0 -5 25 -10 55 -10 30 0 55 5 55 10 0 6 -25 10 -55 10
-30 0 -55 -4 -55 -10z" fill={svgColor}/>

                </g>
            </svg>
        </>
    );
};

export default SolarSvg2;
